import { getRhinoConfig } from '../../init/rhinoConfig';
import { request } from '../../network';

import { getKsAndWaitIfRefreshing } from './deferRefreshKs';
import { handlePhoenixErrors } from './handlePhoenixErrors';
import { phoenixConfig } from './phoenixConfig';
import { KalturaApiResponse } from './type';

type Params = {
  path: string;
  body?: Record<string, unknown>;
};

export async function requestPhoenix<Payload>({ path, body }: Params): Promise<Payload> {
  const ks = await getKsAndWaitIfRefreshing();

  const { isDebug } = getRhinoConfig();

  const { baseUrl, apiVersion, clientTag, language, timeout } = phoenixConfig;

  const queryParams = {
    clientTag,
    // to easily filter Rhino calls in Network inspector, "rhino" param added to url in debug mode
    ...(isDebug && { rhino: '' }),
  };

  const response = await request<KalturaApiResponse<Payload>>({
    url: baseUrl + path,
    queryParams,
    method: 'post',
    timeout,
    body: { ...body, ks, language, apiVersion, clientTag },
  });

  handlePhoenixErrors(response);

  return response.result;
}
